const article = {
    slug: "first_rick_owens_experience",
    category: "BRAND ENTRY",
    title: "初めてのRICK OWENS｜リックオウエンスをレンタル体験",
    listDescription:
      "退廃美、アシンメトリー、ドレープ、黒のシルエット。RICK OWENSを“着ること”から理解する入口ページ。",
    seo: {
      title:
        "初めてのRICK OWENSをレンタル体験｜リックオウエンスを着て知るEnclopedia",
      description:
        "RICK OWENSが気になるけれど、どんなブランドか分からない方へ。リックオウエンスの退廃美、アシンメトリー、ドレープ、レザー、黒・白・グレーのミニマルな色調、DRKSHDW、ジオバスケット、ラモーンズ、Opiumファッションとの関係まで分かりやすく解説し、Enclopediaでレンタルできるアーカイブへ案内します。",
      keyword:
        "初めてのRICK OWENS,RICK OWENS 初めて,リックオウエンス 初めて,RICK OWENS とは,リックオウエンス どんなブランド,RICK OWENS レンタル,リックオウエンス レンタル,RICK OWENS アーカイブ,リックオウエンス アーカイブ,RICK OWENS 着てみたい,リックオウエンス 着てみたい,RICK OWENS Opium,リックオウエンス Opiumファッション,Opiumファッション ブランド,Playboi Carti ファッション,RICK OWENS DRKSHDW,DRKSHDW レンタル,リックオウエンス ジオバスケット,リックオウエンス ラモーンズ,リックオウエンス サルエルパンツ,リックオウエンス レザージャケット,enclopedia,アンクロペディア",
      canonicalPath: "/archive_guide/first_rick_owens_experience",
    },
    hero: {
      label: "FIRST RICK OWENS EXPERIENCE",
      number: "08 / ENTRY",
      titleLines: ["初めての", "RICK OWENSをレンタル体験。"],
      body:
        "RICK OWENSは、\n黒い服やスニーカーのブランドとしてだけでは語れません。\n退廃的な美しさ、アシンメトリー、身体に沿うドレープ、影のような色調。\nグラマラスでありながらアンダーグラウンドでもある、その独自の空気を理解するには、まず実際に着てみるのが自然です。",
      keywords: [
        "first experience",
        "dark elegance",
        "asymmetry",
        "rick owens",
      ],
      visualLabel: "ARCHIVE EXPERIENCE",
      visualTitle: ["黒を着るのではなく、", "影の輪郭をまとう。"],
      image: "media/archive_fashion/archive_guide8.png",
      imageAlt:
        "初めてのRICK OWENSをレンタル体験するためのアーカイブガイド画像",
      ctaLabel: "レンタルできるRICK OWENSを見る",
      ctaHref:
        "https://www.enclopedia-official.com/brand/RICK%20OWENS%EF%BC%88%E3%83%AA%E3%83%83%E3%82%AF%E3%82%AA%E3%82%A6%E3%82%A8%E3%83%B3%E3%82%B9%EF%BC%89/?number=62",
    },
    thesis: {
      text:
        "RICK OWENSは、黒・ドレープ・レザー・アシンメトリーを通して、身体を整えるのではなく、退廃的で彫刻的な存在感へ変えるブランドです。",
      keywords: ["dark elegance", "drape", "asymmetry"],
    },
    sections: {
      whyThisPage: {
        label: "02 / WHY THIS PAGE?",
        titleLines: [
          "RICK OWENSが気になる。",
          "でも、どこから見ればいいか分からない。",
        ],
        body:
          "RICK OWENSは、強い見た目の服やスニーカーで知られる一方、初めて触れる人には“黒くて難しいブランド”に見えることがあります。\nしかし、その魅力は奇抜さだけではありません。\nグラマラスさとアンダーグラウンドを融合させた退廃美、身体に沿うようなドレープ、計算されたカッティング、くすんだシャドウカラー。\nそれらが重なることで、RICK OWENSは単なる黒い服ではなく、身体に別の輪郭を与える服になります。",
      },
  
      brandOverview: {
        label: "03 / BRAND OVERVIEW",
        titleLines: [
          "退廃的で、",
          "彫刻的な身体を作るブランド。",
        ],
        body:
          "RICK OWENSは、アメリカ出身のデザイナー、リック・オウエンスによるブランドです。\n黒、白、グレー、ダストカラーのようなくすんだ色調を軸にしながら、レザー、ドレープ、非対称なカッティング、縦に落ちるシルエットによって、独自の存在感を作ってきました。\nその服は、単に暗いわけでも、単にモードなわけでもありません。\nグラマラスでありながら地下的で、ミニマルでありながら異様。RICK OWENSの面白さは、その矛盾が一着の中で成立しているところにあります。",
        knowledgeItems: [
          {
            title: "退廃美は、汚さではなく緊張感。",
            text:
              "RICK OWENSの退廃的な美しさは、単にダメージ感や暗さを見せるものではありません。削ぎ落とされた色、長く落ちる布、硬質なレザーによって、静かな緊張感を作ります。",
          },
          {
            title: "アシンメトリーは、身体の見え方をずらす。",
            text:
              "左右非対称なカッティングや布の流れは、身体を整えるのではなく、あえて違和感のある輪郭を作ります。その歪みがRICK OWENSらしい存在感になります。",
          },
          {
            title: "ドレープは、身体に沿う影を作る。",
            text:
              "伝統的なオートクチュールを思わせる美しいドレープは、柔らかさだけでなく重力の表現でもあります。布がどこから落ち、どこに溜まるかで、身体の印象が変わります。",
          },
          {
            title: "Opiumファッションの文脈でも参照される。",
            text:
              "Playboi Carti周辺のOpiumファッションでは、黒、レザー、タイトなトップス、ボリュームのあるパンツ、退廃的なムードが重要になります。RICK OWENSはそのスタイルを象徴するブランドの一つとして語られやすい存在です。",
          },
        ],
      },
  
      lineGuide: {
        label: "04 / HOW TO SEE RICK OWENS?",
        titleLines: [
          "RICK OWENSを見るなら、",
          "まず4つの視点から。",
        ],
        items: [
          {
            tag: "ENTRY 01",
            title: "DECADENT ELEGANCE",
            text:
              "退廃的でありながら美しい。暗さ、レザー、ダメージ感、長いシルエットが、ただの粗さではなく洗練されたムードになります。",
          },
          {
            tag: "ENTRY 02",
            title: "ASYMMETRY & CUTTING",
            text:
              "左右非対称の構造、斜めに流れる布、身体に沿うカッティング。RICK OWENSの服は、身体の輪郭を少し異様に見せます。",
          },
          {
            tag: "ENTRY 03",
            title: "DRAPE & SHADOW COLOR",
            text:
              "黒、白、グレー、くすんだ色合い。ミニマルな色調の中で、ドレープや素材の影が服の表情を作ります。",
          },
          {
            tag: "ENTRY 04",
            title: "OPIUM / DRKSHDW / SNEAKERS",
            text:
              "DRKSHDW、ジオバスケット、ラモーンズ、Opiumファッションの文脈は、RICK OWENSを日常のスタイルへ接続する入口になります。",
          },
        ],
      },
  
      firstExperience: {
        label: "05 / FIRST EXPERIENCE",
        titleLines: ["初めて着ると、", "何が分かるのか。"],
        intro:
          "RICK OWENSは、写真で見るよりも、実際に着たときの布の重さ、丈の長さ、身体との距離で理解が深まるブランドです。",
        items: [
          {
            index: "01",
            title: "黒なのに、平坦に見えない理由",
            text:
              "同じ黒でも、レザー、コットン、ジャージー、加工された素材では影の出方が違います。着ると素材ごとの奥行きが分かります。",
          },
          {
            index: "02",
            title: "ドレープとカッティングが身体を変える",
            text:
              "身体に沿うように落ちる布、斜めに流れるライン、長い丈。RICK OWENSの服は、身体をきれいに整えるのではなく、異様で美しい存在感へ変えます。",
          },
          {
            index: "03",
            title: "Opium的なムードが、なぜ成立するのか分かる",
            text:
              "黒、レザー、細長いトップス、ボリュームのあるパンツ、退廃的な空気感。RICK OWENSを着ると、Opiumファッションが単なる流行ではなく、身体のシルエット作りでもあることが分かります。",
          },
        ],
      },
  
      quote: {
        textLines: [
          "暗さではなく、",
          "退廃的な美しさを着る。",
        ],
      },
  
      whyRent: {
        label: "06 / WHY RENT?",
        titleLines: [
          "初めてのRICK OWENSほど、",
          "レンタルで理解が深まる。",
        ],
        items: [
          {
            number: "01",
            title: "サイズ感と丈感を確かめられる",
            text:
              "RICK OWENSはアイテムによって丈、袖、股上、ボリュームの癖が強く、写真や寸法だけでは印象が読み切れません。",
          },
          {
            number: "02",
            title: "ドレープと素材の落ち方が分かる",
            text:
              "レザーや厚手素材、ドレープのある服は、実物で見たときに質感や重力のかかり方がはっきり分かります。",
          },
          {
            number: "03",
            title: "Opium的なスタイルを自分に落とし込めるか試せる",
            text:
              "黒、レザー、ボリュームパンツ、細長いシルエットは、見るのと着るのでは印象が変わります。レンタルは、その距離を測る手段になります。",
          },
        ],
      },
  
      inventory: {
        label: "07 / AVAILABLE ARCHIVE",
        titleLines: ["Enclopediaで", "体験できるRICK OWENS。"],
        body:
          "実在庫への導線は、“RICK OWENSを知る続き”として設計します。まず背景を理解し、次に実物で確かめる流れを作ります。",
        items: [
          {
            meta: "RICK OWENS / 2024SS Lido",
            title: "フォグポケットジャケット",
            text:
              "2024SS “Lido”の、煙や光をまとったような退廃的で彫刻的なムードを背景にした一着。ポケットの存在感と縦に落ちるシルエットで、RICK OWENSらしい影の輪郭を体験できます。",
            href:
              "https://www.enclopedia-official.com/product/e0429065-ee65-4314-b044-f436ed8fd02e",
            image:
              "media/product/1758033863.7903013e0429065-ee65-4314-b044-f436ed8fd02e.jpg",
          },
          {
            meta: "RICK OWENS DRKSHDW / 2023SS",
            title: "JUMBO WORKER JKT",
            text:
              "DRKSHDWらしい日常性とワークウェアの骨格を、ジャンボシルエットでRICK OWENSのバランスへ引き上げたジャケット。ストリートに取り入れやすく、ブランドのムードを体験しやすい一着です。",
            href:
              "https://www.enclopedia-official.com/product/46717e68-e9fa-4899-b9e0-72b228b6bb52",
            image:
              "media/product/1771165505.634241346717e68-e9fa-4899-b9e0-72b228b6bb52.jpg",
          },
        ],
      },
  
      faq: {
        label: "08 / FAQ",
        titleLines: ["初めての人が、", "気になりやすいこと。"],
        items: [
          {
            question: "RICK OWENSは、どんなブランドですか？",
            answer:
              "黒、ドレープ、レザー、アシンメトリーなカッティングを通じて、身体に退廃的で彫刻的な存在感を与えるブランドです。グラマラスさとアンダーグラウンドなムードが同居しています。",
          },
          {
            question: "RICK OWENSはOpiumファッションと関係がありますか？",
            answer:
              "公式に同じものではありませんが、Playboi Carti周辺のOpiumファッションでは、黒、レザー、細長いトップス、ボリュームパンツ、退廃的なムードが重視され、RICK OWENSはその代表的な参照ブランドの一つとして語られやすい存在です。",
          },
          {
            question: "RICK OWENSとDRKSHDWは違いますか？",
            answer:
              "DRKSHDWはRICK OWENSの中でも、より日常的でストリート寄りに取り入れやすいラインとして理解できます。スニーカーやパンツから入る人も多いです。",
          },
          {
            question: "初めてなら、どのアイテムから見るのがおすすめですか？",
            answer:
              "スニーカー、パンツ、カットソー、ドレープのあるトップスなど、日常着に近い形を持ちながらブランドの雰囲気が分かるアイテムがおすすめです。",
          },
          {
            question: "写真と実物で印象は変わりますか？",
            answer:
              "変わります。丈感、布の重さ、レザーの質感、身体との距離は実物でないと理解しづらい要素です。",
          },
          {
            question: "レンタル後に購入もできますか？",
            answer:
              "対象アイテムは、レンタル体験を経たうえで購入相談へ進める導線を想定しています。",
          },
        ],
      },
  
      finalCta: {
        titleLines: [
          "初めてのRICK OWENSを、",
          "レンタルから始める。",
        ],
        body:
          "退廃美、アシンメトリー、ドレープ、レザー、影のあるシルエット。\nEnclopediaで、RICK OWENSのアーカイブを体験してください。",
        buttonLabel: "レンタルできるRICK OWENSを見る",
        buttonHref:
          "https://www.enclopedia-official.com/brand/RICK%20OWENS%EF%BC%88%E3%83%AA%E3%83%83%E3%82%AF%E3%82%AA%E3%82%A6%E3%82%A8%E3%83%B3%E3%82%B9%EF%BC%89/?number=62",
      },
    },
  };

export default article;
